import { render, staticRenderFns } from "./AdminGradeBook.vue?vue&type=template&id=617138fb"
import script from "./AdminGradeBook.vue?vue&type=script&lang=js"
export * from "./AdminGradeBook.vue?vue&type=script&lang=js"
import style0 from "./AdminGradeBook.vue?vue&type=style&index=0&id=617138fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports